import React from 'react';
import { Sparkles, User, Heart, Eye } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ServicesSection = () => {
  const { t } = useLanguage();

  const services = [
    {
      id: 'trasplante-capilar',
      icon: Sparkles,
      title: t('services.service1'),
      description: t('services.service1Desc'),
      span: 'col-span-1 md:col-span-2',
      featured: true
    },
    {
      id: 'injerto-barba',
      icon: User,
      title: t('services.service2'),
      description: t('services.service2Desc'),
      span: 'col-span-1',
      featured: false
    },
    {
      id: 'injerto-mujeres',
      icon: Heart,
      title: t('services.service3'),
      description: t('services.service3Desc'),
      span: 'col-span-1',
      featured: false
    },
    {
      id: 'injerto-cejas',
      icon: Eye,
      title: t('services.service4'),
      description: t('services.service4Desc'),
      span: 'col-span-1 md:col-span-2',
      featured: true
    }
  ];

  return (
    <section id="servicios" className="py-20 md:py-28 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-semibold tracking-wider uppercase text-[#009d9f] mb-4">
            {t('services.tagline')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {t('services.title')}{' '}
            <span className="text-[#009d9f]">{t('services.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-slate-600">
            {t('services.description')}
          </p>
        </div>

        {/* Services Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="services-grid">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`${service.span} group relative overflow-hidden rounded-3xl bg-white p-8 border border-slate-100 hover:border-[#14B8A6] transition-all duration-300 service-card ${
                service.featured ? 'bg-gradient-to-br from-[#F0FDFA] to-white' : ''
              }`}
              data-testid={`service-card-${index}`}
            >
              {/* Icon */}
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-6 ${
                service.featured 
                  ? 'bg-[#009d9f] text-white' 
                  : 'bg-[#CCFBF1] text-[#009d9f]'
              }`}>
                <service.icon className="w-7 h-7" />
              </div>

              {/* Content */}
              <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {service.description}
              </p>

              {/* Decorative element */}
              <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-[#009d9f]/5 rounded-full group-hover:scale-150 transition-transform duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
